import { useCallback } from "react";
import { axiosV2 } from "../candidates/axios";

export interface IPostSanctionRadiation {
  candidateId: string;
  justificationDemandeRadiation: string;
}

export const usePostSanctionRadiation = () => {
  const [state, execute, cancel] = axiosV2<null, IPostSanctionRadiation>(
    {
      method: "POST",
      withCredentials: true,
    },
    { manual: true }
  );

  const callback = useCallback(
    (data: IPostSanctionRadiation) =>
      execute({
        url: "/candidates/sanctions/radiation",
        data,
      }),
    [execute]
  );

  return [state, callback, cancel] as const;
};
